import { gql } from '@apollo/client';

export const GET_ADS_BY_LINE_ITEM_ID_LIST = gql`
  query GET_ADS_BY_LINE_ITEM_ID_LIST($lineItemIdList: [ID!]!, $offset: Int!, $limit: Int!) {
    ads: adsV5(
      filterOptions: { lineItemIdList: $lineItemIdList }
      paginationOptions: { offset: $offset, limit: $limit }
    ) {
      edges {
        node {
          id
          name
          startDate
          endDate
          trackingId
          type
          lineItem {
            id
            name
            countries
            parentLineOmsLink {
              id
            }
          }
          adRotation {
            rotationId
          }
          adSequence {
            adId
            name
            order
            sequenceId
            updatedAt
            podPosition
            podAlignment
          }
        }
      }
      total
    }
  }
`;
